import React from 'react';
import { journeySteps } from '../data/resinContent';
type JourneyStripProps = {
  className?: string;
};
export function JourneyStrip({
  className = ''
}: JourneyStripProps) {
  return <ol className={`flex flex-wrap items-center justify-center gap-x-2.5 gap-y-2 sm:gap-x-4 ${className}`} aria-label="The six steps of the system" data-id="element-193" data-mp="2ysmiaw87bhgr">
      {journeySteps.map((step, i) => <li key={step} className="flex items-center gap-2.5 sm:gap-4" data-id="element-194" data-mp="263p2r0vdjyrp" data-mpi={i}>
          <span className="text-[11px] font-semibold uppercase tracking-[0.2em] text-ivory-100 sm:text-[12px]" data-id="element-195" data-mp="2661qxvrq75d7">
            {step}
          </span>
          {i < journeySteps.length - 1 && <span className="text-champagne" aria-hidden="true" data-id="element-196" data-mp="2f2k86aqlh4ty">
              →
            </span>}
        </li>)}
    </ol>;
}